import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { TrnxCommonTs } from 'src/app/shared/common/trnxCommonTs';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { VaultobjectPopupScreenComponent } from '../vaultobject-popup-screen/vaultobject-popup-screen.component';
import { constants } from 'src/app/shared/common/contants';

@Component({
    selector: 'app-datasetgroup-popup-screen',
    templateUrl: './datasetgroup-popup-screen.component.html',
    styleUrls: ['./datasetgroup-popup-screen.component.scss'],
    standalone: false
})
export class DatasetgroupPopupScreenComponent implements OnInit {

  validations_form: UntypedFormGroup;
  ObjectGrid:any;
  paramstemp;
  ObjectsData:any=[];
  vaultGroup:any=[]
  columnDefsForObjects;
  datasetGroupData={"description":"", "datasetGroupName":"",datasetsid: []}
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any= [];
  temp: any = [];
  selectedTableFields: any;
  gridApi;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen="";
  buttonColor="";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean= false;
  // columnDefs;
  value
  retrieveObject: any = [];
  setObject:any=[];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";

  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName:any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  editmode;
  update

  // reportCreationDuplicate: any = [];


  constructor(private dialogref: MatDialogRef<VaultobjectPopupScreenComponent>,private validation: validationmethod,private service: ReportingServiceService,private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,private constants: constants,private msg: ErrorMessages,private fb: UntypedFormBuilder,private linkservice: ReportlinksserviceService,private localStorageSettings: LocalStorageSettingsService,private vaultObjectService: VaultObjectgroupService, private trnxCommonTs: TrnxCommonTs,private commonService:CommonService) {
    this.validation_messages = this.msg.reportConfiguration;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      groupname:new UntypedFormControl('',[Validators.required,this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
      description:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
    });
  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }

  ngOnInit() {
    this.validations_form = this.fb.group({
      groupname: '',
      description: ''
    });

    this.formValidation();

    // While unit testing it is added.
    this.formValidCheckbox = this.fb.group({
      isCheckboxSelected: ''
    });

    // this.lookupVaultGroup();

    this.columnDefsForObjects = [
      {
        headerName: "Datasets",
        headerTooltip: "Datasets",
        tooltipValueGetter: params => "Dataset : " + params.value,
        field: "datasetname",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Dataset",
        headerTooltip: "Selected  Dataset",
        tooltipValueGetter: params => "Selected  Dataset : " + params.value,
        field: "datasetname",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // save and update button toggle
    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    this.buttonName = this.buttonName;

    console.log(this.buttonName);

    this.formValidationsCheckbox();

    //To different master and transaction screens.
    // if (this.screenTypeTOrM == "Transaction") {

    //   this.nextSaveTOrM = "Next";

    // }

    // else {

    //   this.nextSaveTOrM = "Save";

    // }
    // this.reportCreationDuplicate.push();
  }

  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.linkservice.retrievereportlinks().subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }

 async onGridReadyForObjects(params){
  this.tableFields=[];
  this.selectedObjects=[];
  let response:any;
  this.ObjectGrid=params;
  this.spinner.start();
  let tableName="reportcreation";
  let uniq1={};
  response=await  this.commonService.retrieveRecordService(tableName);
  console.log(response);

  response =response.filter(obj => !uniq1[obj.datasetname] && (uniq1[obj.datasetname] = true));
  console.log(response);


  this.ObjectGrid.api.setGridOption('rowData', response);
  if(tableName === undefined){
        this.ObjectGrid.api.setGridOption('rowData', []);
      }else{
        let uniq={};
      this.tablefields = response;
        this.tableFields.filter(obj => !uniq[obj.datasetname] && (uniq[obj.datasetname] = true));

      console.log(this.tablefields)
      this.gridApiForTablesFields = params;
      this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
      this.selectedObjects.api.setGridOption('rowData', []);
      }
      this.gridApiForTablesFields.setGridOption('rowData', response);

      this.gridApiForTablesFields = params.api;

}



  onRowSelected(event) {

    this.fieldsData = this.ObjectGrid.api.getSelectedRows();

    this.selectedObjects = this.fieldsData;

    console.log(this.selectedObjects);
}

  onGridReadyForSelectedTableFields(params,data) {

    console.log(params);
    console.log(data)
    this.selectedTableFields=params
    this.selectedFieldsDataToPush=data;
    // console.log(this.selectedFieldsDataToPush);
    //this.gridApiForTablesFields = params.api;
    console.log(data);
    this.selectedTableFields.api.setGridOption('rowData', data);
    //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }

  // modified by Aman Singh
// updated the button functionalities

   //forward Icon Function decleation
   pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.selectedObjects,'selected datasets');
    for (let i = 0; i < this.selectedObjects.length; i++) {
      console.log(this.selectedObjects[i])
      if(!this.datasetGroupData.datasetsid.includes(this.selectedObjects[i].reportcreationid)){
        this.datasetGroupData.datasetsid.push(this.selectedObjects[i].reportcreationid)

      }
    }
    console.log("=========================================")
    console.log(this.datasetGroupData)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedObjects.filter(obj => !uniq[obj.datasetname] && (uniq[obj.datasetname] = true));
        console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  }

  //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.tablefields);

    // //duplicates data not allowed
   this.temp = this.tablefields.filter(obj => !uniq[obj.datasetname] && (uniq[obj.datasetname] = true));
        console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(true)

    })
    for (let i = 0; i < this.temp.length; i++) {
      console.log(this.selectedObjects[i])
      if(!this.datasetGroupData.datasetsid.includes(this.temp[i].reportcreationid)){
        this.datasetGroupData.datasetsid.push(this.temp[i].reportcreationid)

      }
    }
    console.log(this.datasetGroupData.datasetsid);
    //this.pushDataToSelectedFieldsGrid();
  }

  //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedObjects.length = 0
    this.temp.length = 0
    this.datasetGroupData.datasetsid=[];
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,[])
    // this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(false)

    })
    console.log(this.datasetGroupData.datasetsid);

  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedObjects = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));



    for (let o = 0; o < this.fieldsDataToRemove.length; o++) {
      this.ObjectGrid.api.forEachNode(node => {
        if (node.data.datasetname === this.fieldsDataToRemove[o].datasetname) {
          node.setSelected(false)
        }
      })
    }
  this.datasetGroupData.datasetsid=[];
    for (let i = 0; i < this.selectedObjects.length; i++) {
      console.log(this.selectedObjects[i])
      if(!this.datasetGroupData.datasetsid.includes(this.selectedObjects[i].reportcreationid)){
        this.datasetGroupData.datasetsid.push(this.selectedObjects[i].reportcreationid)

      }
    }
    console.log(this.datasetGroupData.datasetsid);

  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }



  save(){
    this.validations_form.markAllAsTouched();
    this.formValidCheckbox.markAllAsTouched();

  // Stop execution if form is invalid
  if (this.validations_form.invalid || this.formValidCheckbox.invalid) {
    this.snackbar.open("Please fill all required fields", "OK", {
      duration: 5000,
    });
    return;
  }
    console.log(this.selectedFieldsDataToPush);
    console.log(this.isCheckboxSelected);
  console.log(this.datasetGroupData);
  this.spinner.start();
     this.vaultObjectService.insertDatasetGroup(this.datasetGroupData).subscribe(response => {

       console.log(response)
        // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }
      else if(this.isCheckboxSelected == true)
      {
        this.datasetGroupData.datasetsid = [];
        this.validations_form.reset();
        this.formValidCheckbox.reset();
        this.ObjectGrid.api.deselectAll();
        this.selectedObjects=[];
        this.selectedTableFields.api.setGridOption('rowData', []);
        // this.ObjectGrid.api.setGridOption('rowData', []);
        let tableName="reportcreation";
        let response=  this.commonService.retrieveRecordService(tableName);
        this.snackbar.open('Dataset Group created successfully', "OK", {
          duration: 5000,
        });
        this.ObjectGrid.api.setRowData.reset();
        if(tableName === undefined){
            this.ObjectGrid.api.setRowData.reset();
          }else{
          this.tablefields = response;
          console.log(this.tablefields)
          this.ObjectGrid.api.setRowData.reset();
          this.selectedObjects.api.setRowData.reset();
          }
          // this.gridApiForTablesFields.setRowData.reset();
          // this.fieldsData = this.ObjectGrid.api.getSelectedRows.reset();
          // this.selectedObjects = this.fieldsData;
      }
       else {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.dialogref.close();
        this.cancel();
      }
      // this.spinner.stop();
      // this.onGridReady(this.rowbindingdata);

      console.log(this.isCheckboxSelected);
      // this.isCheckboxSelected = true;
      // if (this.isCheckboxSelected == true){
      //   this.validations_form.reset();
      //   this.formValidCheckbox.reset();
      // }
      // else{
      //   this.dialogref.close();
      //   this.cancel();
      //   // this.reportCreationDuplicate.push(response);
      //   // this.spinner.start();
      // }
      this.spinner.stop();

    });
   this.spinner.stop();
  }


  // async next(value) {
  //   console.log(value)
  //   // checking the form is valid or not while insert
  //   if (!this.formValid.valid) {

  //     // displaying validation messages

  //     this.validation.validateAllFormFields(this.formValid);

  //     this.validation.getvalidationmessage();

  //   }
  // }

  close(){
    console.log(this.isCheckboxSelected);
    console.log(typeof this.isCheckboxSelected);
    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.validations_form.reset();
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      // this.datasetGroupData = [];

      this.dialogref.close();

    }
  }
  cancel() {
  // this.formValidCheckbox.reset();
  // this.formValidationsCheckbox();
  this.isCheckboxSelected = false;
   this.datasetGroupData= {
    description: "",
    datasetGroupName: "",
    datasetsid: [],
   }
   this.dialogref.close();

   this.close();
   window.location.reload();
  }

}
